import { mode } from '@chakra-ui/theme-tools';
import { getCSSVar } from '@chakra-ui/utils';
const getBaseStyle = (props) => {
    const bg = mode('gray.500', 'gray.100')(props);
    return {
        px: '8px',
        py: '6px',
        bg,
        '--popper-arrow-bg': getCSSVar(props.theme, 'colors', bg),
        color: mode('white', 'gray.600')(props),
        borderRadius: 'base',
        fontWeight: 'regular',
        fontSize: 'sm',
        lineHeight: 1.4,
        boxShadow: 'none',
        maxW: '3xs',
        zIndex: 'tooltip',
    };
};
export default {
    baseStyle: getBaseStyle,
};
//# sourceMappingURL=tooltip.js.map